<template>
    <div class="modal-body pt-0 pb-0 pl-0 pr-0">
        <div class="card lists mb-0">
            <div class="card-header">
                <div class="row align-items-center pt-3">
                    <div class="col">
                        <div class="row align-items-center">
                            <div class="col-12 col-md-4 col-lg-3 mb-3 mb-3 mb-md-0 pr-3 pr-md-0">
                                <div class="input-group input-group-merge">
                                    <input v-model="search" type="search" class="form-control form-control-prepended" placeholder="Tìm rạp tại">
                                    <div class="input-group-prepend">
                                        <div class="input-group-text">
                                            <span class="fe fe-search"></span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-md-5 col-lg-4">
                                <select
                                    class="form-control btn-select-region search"
                                    data-toggle="select"
                                    v-model="region"
                                >
                                    <option
                                        v-for="region in regions"
                                        :key="region.id"
                                        :value="region.id"
                                    >
                                      {{ region.name }}
                                    </option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="col-auto"></div>
                </div> <!-- / .row -->
            </div>

            <div class="pt-3" v-if="cinemas.length > 0">
                <div class="border-bottom" v-for="cinema in filteredCinemas" :key="cinema.id">
                    <div class="row align-items-center pl-4 pr-4 pb-3 pt-3">
                        <div class="col-auto">
                            <a :href="url('cinema_view', { slug: cinema.slug })"
                               class="avatar avatar-sm">
                                <img :src="cinema.cineplex && cinema.cineplex.logo ? cinema.cineplex.logo.sizes.square : asset('bundles/ornweb/img/no-thumbnail.png')"
                                     :data-src="cinema.cineplex && cinema.cineplex.logo ? cinema.cineplex.logo.sizes.square : asset('bundles/ornweb/img/no-thumbnail.png')"
                                     :alt="cinema.name" class="lazyload avatar-img rounded-circle">
                            </a>
                        </div>
                        <div class="col ml-n2">
                            <h4 class="card-title mb-1">
                                <a :href="url('cinema_view', { slug: cinema.slug })" class="name mr-1">
                                    {{ cinema.name }}
                                </a>
                                <span class="badge badge-soft-primary" v-if="cinema.adapter === 'ticketing' || cinema.adapter === 'affiliate'">bán vé</span>
                                <span class="badge badge-soft-primary" v-if="cinema.adapter === 'voucher'">bán voucher</span>
                            </h4>
                            <p class="card-text small text-muted address mb-0">
                                {{ cinema.address }}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, computed, watch, onMounted, inject } from 'vue'
import axios from 'axios'

const root = inject('root')
const search = ref('')
const region = ref(root.getRegion())
const cinemas = ref([])
const regions = ref([])
const errors = ref([])

const filteredCinemas = computed(() => {
  return cinemas.value.filter(cinema => {
    return cinema.name.toLowerCase().includes(search.value.toLowerCase())
  })
})

const getRegion = async () => {
  try {
    const response = await axios.get(`/api/regions`)
    regions.value = response.data
  } catch (error) {
    errors.value.push(error)
  }
}

const getCinemas = async (page = 1) => {
  try {
    const baseUri = process.env.MOVEEK_API_ENDPOINT
    const response = await axios.get(
      `${baseUri}/v1/cinemas?region.id=${region.value}&status=publish&closed=false&opening_soon=false&page_size=100&order[cineplex.name]=ASC&order[name]=ASC&page=${page}`
    )

    cinemas.value = [...cinemas.value, ...response.data]

    if (response.data.length === 100) {
      await getCinemas(page + 1)
    } else {
      cinemas.value = cinemas.value.map(cinema => {
        if (!cinema.cineplex) {
          cinema.cineplex = {
            id: 0,
            name: 'Khác',
            logo: {
              sizes: {
                'tiny': root.asset('bundles/ornweb/img/no-thumbnail.png'),
                'square': root.asset('bundles/ornweb/img/no-thumbnail.png')
              }
            },
            sponsored: false
          }
        }
        return cinema
      })

      cinemas.value.sort((x, y) => y.sponsored - x.sponsored || y.cineplex.sponsored - x.cineplex.sponsored)
    }
  } catch (error) {
    errors.value.push(error)
  }
}

const url = (routeName, params) => {
  return root.url(routeName, params)
}

const asset = (path) => {
  return root.asset(path)
}

watch(region, () => {
  cinemas.value = []
  getCinemas()
})

onMounted(async () => {
  await getRegion()
  await getCinemas()
})
</script>

<style scoped>
</style>
